import gql from 'graphql-tag';
import { MINIMAL_BUSINESS_FRAGMENT } from '../business/fragment';

export const DISCUSSION_MESSAGE_CONTENT_FRAGMENT = gql`
  fragment DiscussionMessageContentFragment on DiscussionMessageContent {
    id
    uri
    width
    height
    length
    text
    poster
  }
`;

export const DISCUSSION_MESSAGE_FRAGMENT = gql`
  fragment DiscussionMessageFragment on DiscussionMessage {
    id
    createdAt
    recordDirectoryToken
    sender {
      id
      firstName
      lastName
      avatarUrl
    }
    discussionOrigin {
      id
    }
    content {
      id
      uri
      width
      height
      length
      text
      poster
    }
    contentType
    status
    isSeenByMe
    isSeenByUsers {
      id
      avatarUrl
    }
    isDeleted
    business {
      ...BusinessInfo
    }
    isQuotation
    quotedFrom {
      id
      createdAt
      content {
        id
        text
      }
      contentType
      tags
    }
    tags
  }
  ${MINIMAL_BUSINESS_FRAGMENT}
`;

export const MINIMAL_DISCUSSION_MESSAGE_FRAGMENT = gql`
  fragment MinimalDiscussionMessageFragment on DiscussionMessage {
    id
    createdAt
    content {
      id
      text
    }
  }
`;

export const DISCUSSION_FRAGMENT = gql`
  fragment DiscussionFragment on Discussion {
    id
    name
    avatarUrl
    unseenMessageNumber
    lastMessage {
      id
      createdAt
      content {
        id
        length
        text
        uri
      }
      contentType
      isSeenByMe
      isDeleted
    }
    lastMessageDate
  }
`;
